import { combineReducers } from '@reduxjs/toolkit';
import bottomModalReducer from './bottomModal/bottomModalSlice';
import courseCertificateReducer from './courseCertificate/courseCertificateSlice';
import creditsReducer from './credits/creditsSlice';
import editProfileReducer from './editProfile/editProfileSlice';
import loadingReducer from './loading/loadingSlice';
import profileReducer from './profile/profileSlice';
import totalCreditsReducer from './totalCredits/totalCreditsSlice';

export const reducers = combineReducers<any>({
  profile: profileReducer,
  editProfile: editProfileReducer,
  bottomModal: bottomModalReducer,
  credits: creditsReducer,
  courseCertificate: courseCertificateReducer,
  totalCredits: totalCreditsReducer,
  loading: loadingReducer,
});

export type RootState = ReturnType<typeof reducers>;
